var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"candidateAvatar"},[_c('span',{class:{
      'candidateAvatar__border': _vm.hasBorder,
      'candidateAvatar__circle': _vm.variant === 'circle',
    }},[_c('img',{class:{
        'candidateAvatar__circle': _vm.variant === 'circle',
      },attrs:{"src":_vm.gravatarUrl.normal,"srcset":`${_vm.gravatarUrl.retina} 2x`,"alt":"User avatar","width":_vm.size,"height":_vm.size}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }